// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { filter16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-filter': IconFilter;
    }
}

/**
 * The icon component for the 'filter' icon
 */
export class IconFilter extends IconSvg {
    public constructor() {
        super(filter16X16);
    }
}

registerIconSvg('icon-filter', IconFilter);
export const iconFilterTag = 'nimble-icon-filter';
